import { Field, Form, Formik } from 'formik'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'underscore'
import * as yup from 'yup'
import { postFeedback } from '../../api/support'
import { setOpenSupportModal } from '../../redux/slices/modal'
import { supportSelector } from '../../redux/slices/support'
import { fetchFeedbackTypes } from '../../redux/thunks/support'
import { phoneMatch } from '../../utils/phone'
import FormObserver from '../reusable/Form/FormObserver'
import InputComponent from '../reusable/Form/InputComponent'
import ErrorMessage from '../reusable/Messages/ErrorMessage'
import SupportAgree from './Agree'
import SupportButtons from './Buttons'

const SupportForm = () => {
  const formikRef = useRef(null)
  const { feedbackTypes } = useSelector(supportSelector)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchFeedbackTypes())
  }, [dispatch])

  const initialValues = {
    full_name: '',
    email: '',
    phone: '',
    type_id: '',
    content: '',
    agree: false,
  }

  const emailValidation = yup.string().email('Невалідний email')
  const phoneValidation = yup
    .string()
    .matches(phoneMatch, 'Номер має починатися з +380 і містити 12 цифр')

  const validationSchema = yup
    .object()
    .shape({
      full_name: yup
        .string()
        .trim()
        // .strict(true)
        .required('Заповніть поле')
        .matches(/^[\p{L}]+([ '-][\p{L}]+)*$/u, 'Некоректний формат ПІБ'),
      email: emailValidation,
      phone: phoneValidation,
      type_id: yup.string().required('Оберіть значення'),
      content: yup.string().trim().required('Заповніть поле'),
      agree: yup.boolean().oneOf([true], 'Надайте згоду').required('Надайте згоду'),
    })
    .atLeastOneRequired(['email', 'phone'], 'Введіть email або телефон')

  const handleSubmit = async (values) => {
    console.log('handleSubmit')
    const { agree, phone, full_name, content, ...rest } = values
    const formValues = {
      ...rest,
      phone: phone ? '+380' + phone : '',
      full_name: full_name.trim(),
      content: content.trim(),
    }
    console.log(formValues)
    // return
    if (agree) {
      const res = await postFeedback(formValues)
      if (res?.status === 1) {
        formikRef.current?.resetForm()
        dispatch(setOpenSupportModal(true))
      }
    }
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {(props) => {
        const {
          errors,
          values: { email, phone },
        } = props
        // console.log('SupportForm props', props)
        // console.log({ email, phone })
        return (
          <Form className="support_form">
            <FormObserver />
            <Field
              required
              label="ПІБ"
              name="full_name"
              placeholder="Ваше ПІБ"
              component={InputComponent}
            />
            <div className="or_block">
              <Field
                required={(!phone && !email) || email} // just to show asterisk
                label="E-mail"
                name="email"
                placeholder="Ваш E-mail"
                component={InputComponent}
              />
              <span className="or">або</span>
              <Field
                required={(!phone && !email) || phone} // just to show asterisk
                phone
                label="Номер телефону"
                name="phone"
                //type="tel"
                component={InputComponent}
              />
            </div>
            <Field
              select
              required
              label="Тип проблеми"
              name="type_id"
              placeholder="Оберіть тип проблеми"
              options={feedbackTypes}
              optionsKeys={{ valueKey: 'type_id', labelKey: 'name_uk' }}
              component={InputComponent}
            />
            <Field
              textarea
              required
              label="Звернення"
              name="content"
              placeholder="Ваше звернення"
              component={InputComponent}
            />

            <SupportAgree />
            {!_.isEmpty(_.omit(errors, 'agree')) && (
              <ErrorMessage msg="Перевірте всі поля та виправте помилки." />
            )}
            <SupportButtons />
          </Form>
        )
      }}
    </Formik>
  )
}

export default SupportForm
